<template>
    <div>
      <div class="tile-container" @click="updateSelected">
        <div class="icon-container">
          <fa-icon :icon="['fal', icon]"/>
        </div>
        <div class="text-container">
          <div class="title">{{title}}</div>
          <div class="description">
            {{description || ''}}
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'OnboardingSelectionTile',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    selected: {
      type: Boolean,
      // required: true,
      default: false
    },
    icon: {
      type: String,
      default: 'shirt',
    }
  },
  mounted() {
    console.log('OnboardingSelectionTile', this.selected);
  },
  computed: {
  },
  methods: {
    updateSelected() {
      console.log('updateSelected', !this.selected, this.title);
      this.$emit('input', !this.selected);
    }
  }

};

</script>

<style lang="scss" scoped>
// style
.tile-container{
  cursor: pointer;
  background: white;
  // border: 0.5px solid $primary;
  box-shadow: rgba(50, 50, 105, 0.1) 0px 2px 3px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
   margin: 0.5rem;
  transition: all 0.3s ease-in-out;
  @media screen and (min-width: 768px) {
    &:hover{
      background: var(--highlight-color);
      color: var(--text-color-primary);
      .text-container{
        color: var(--text-color-primary);
        .title{
          color: var(--text-color-primary);
        }
      }
    }
  }
  svg {
    font-size: 3rem;
  }
  .icon-container{
    width: 100px;
    margin: 0 auto;
    height: 100px;
    // background: #D9D9D9;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    i{
      font-size: 50px;
      color: var(--highlight-color);
    }
  }
  .text-container{
    padding: 0px 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .title{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      font-style: normal;
      // font-weight: bold;
      font-size: 1rem;
      line-height: 21px;
      color: #000000;
      line-height: 1.2em;
      height: 2.4em;       /* height is 2x line-height, so two lines will display */
    }
    .description{
      line-height: 1em;
      // height: 1em;       /* height is 2x line-height, so two lines will display */
      max-height: 4em;       /* height is 2x line-height, so two lines will display */
      overflow: hidden;
    }

  }
}
</style>
